import { connect } from 'react-redux'
import GatewayAdaptersForm from '../components/gateway-adapter-form/gateway-adapter-form'
import MemoryStore from '../../utils/memory-store'
import { saveProfile } from '../gateway-adapters-actions'
import { fetchAllData, closeTab } from '../../core/core-actions'
import Enums from '../../utils/enums'

const mapStateToProps = (state) => {
  if (!state[state.core.tabObject.activeApp]) {
    return {}
  }

  const appId = state.core.tabObject.activeApp
  const tabKey = state.core.tabObject.activeKey
  const tabs = state.core.tabObject.tabs
  const entry = MemoryStore.activeEntries[tabKey]
  let title = Enums.VALUES_STRINGS.NEW_PROPER_CASE + Enums.VALUES_STRINGS.SPACE + Enums.APP_PROFILE_TITLES[appId]

  if (entry && entry.data && !entry.custom.isNewDoc) {
    title = Enums.APP_PROFILE_TITLES[appId] + Enums.VALUES_STRINGS.COLON + Enums.VALUES_STRINGS.SPACE + entry.data.name
  }

  return {
    appId,
    tabKey,
    tabs,
    title,
    state: state.gatewayadapters,
    theme: state.core.theme
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    closeTab: (activeKey, targetKey, tabs) => {
      dispatch(closeTab(activeKey, targetKey, tabs))
    },
    saveProfile: (appId, activeKey, state, publish, callback) => {
      dispatch(saveProfile(appId, activeKey, state, publish, callback))
    },
    fetchAllData: (appId, callback) => {
      dispatch(fetchAllData(appId, callback))
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(GatewayAdaptersForm)
